import { PARTNER_IDS, type PartnerCode } from 'src/constants/partners';
import { isSSR } from './ssr';

export const isPartner = (partner: PartnerCode): boolean =>
  !isSSR && Boolean(window.PARTNER?.id === PARTNER_IDS[partner]);
